import axios from "axios"

const SendEmail = (email:string)=>{
    axios.post(process.env.REACT_APP_MAIL_MICORSERVICE + "/mailjet/add-contact", {email})
}
export default SendEmail